import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { RouteType } from "../models/enum";
import { GoogleAuthService } from "./google-api.service";
import { isOfflineWorkRoute } from "./offline-work-route.utils";
import { setReturnUrl } from "./return-url.utils";
import { SESSION } from "src/session.config";

@Injectable({
	providedIn: "root",
})
export class AuthGuardService {
	constructor(
		private authService: GoogleAuthService,
		private router: Router,
	) {}

	async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		const hasCachedUser = !!localStorage.getItem(SESSION.SESSION_KEY_USER);

		// Offline on pending/ratings: keep local work with a cached profile.
		if (!navigator.onLine && isOfflineWorkRoute(state.url) && hasCachedUser) {
			return true;
		}

		if (!navigator.onLine) {
			if (this.authService.hasValidOfflineSession()) return true;
			this.redirectToLogin(state.url);
			return false;
		}

		if (await this.authService.ensureSessionResolved()) return true;
		this.redirectToLogin(state.url);
		return false;
	}

	private redirectToLogin(returnUrl: string): void {
		setReturnUrl(returnUrl);
		this.router.navigate([RouteType.LOGIN], {
			queryParams: { returnUrl },
		});
	}

	getTokenExpiry(): void {
		this.authService.getTokenExpiry();
	}

	checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {
		const data = (route.data as { role: string }) ?? {};
		const userRole = this.authService.getRoles();

		if (this.authService.isLoggedIn() && userRole.includes(data.role)) {
			return true;
		}

		this.router.navigate([url]);
		return false;
	}
}
